@if (workflowHistoryData) {
    <cerrix-workflow-history-graph [workflowHistory]="workflowHistoryData">
        <ng-template #extraTableHeaders>
            <div>{{ 'effWorkflowHistory.score' | t }}</div>
        </ng-template>
        <ng-template #extraTableValues let-row="row">
            <div [title]="row.score">
                @if (row.score) {
                    <div style="display: flex; flex-flow: row">
                        <div style="display: flex; flex-flow: column; justify-content: center">
                            <div
                                style="
                                    min-width: 14px;
                                    max-width: 14px;
                                    min-height: 14px;
                                    max-height: 14px;
                                    margin-right: 10px;
                                    border-radius: 3px;
                                "
                                [style.background-color]="row.scoreColor"
                            ></div>
                        </div>
                        <div>{{ row.score }}</div>
                    </div>
                }
            </div>
        </ng-template>
    </cerrix-workflow-history-graph>
}
